import { render, staticRenderFns } from "./UjianMapel.vue?vue&type=template&id=06598d66&scoped=true"
import script from "./UjianMapel.vue?vue&type=script&lang=js"
export * from "./UjianMapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06598d66",
  null
  
)

export default component.exports